<script lang="ts"></script>

<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [Container]
 * Обертка для модального окна
 */

// Hooks
import { computed } from "vue";
// import useExecutingStatus from "@/hooks/useExecutingStatus";

// Components
import RolledStatus from "@/components/rolledStatus/rolledStatus.vue";
import { useOperatorExecutingStore } from "@/stores/operatorExecuting/operatorExecuting";
// Store
import { useTIWStore } from "@/stores/tiw/tiw";

const TIWStore = useTIWStore();
const OperatorExecutingStore = useOperatorExecutingStore();

const classes = computed(() => {
    const classList: string[] = ["tiw", "tiw__container"];

    if (TIWStore.modeIsEmbed) {
        classList.push("tiw_open");
        classList.push("tiw_embed");
    }

    if (TIWStore.modeIsPopup) {
        if (TIWStore.IS_CLOSE) classList.push("tiw_close");
        if (!TIWStore.IS_CLOSE) classList.push("tiw_open");
        if (TIWStore.IS_ROLL) classList.push("tiw_open_rollDown");
        if (TIWStore.IS_TRANSITION) classList.push("tiw_transition");
    }

    return classList;
});

const styles = computed(() => {
    const styleRules: Record<string, string> = {};

    if (TIWStore.customStyles.font.family) {
        styleRules["--custom-font-family"] = TIWStore.customStyles.font.family;
    }

    if (TIWStore.customStyles.font.size) {
        styleRules["--custom-font-size"] = `${TIWStore.customStyles.font.size}px`;
    }

    if (TIWStore.customStyles.color.text) {
        styleRules["--custom-color-text"] = TIWStore.customStyles.color.text;
    }

    if (TIWStore.customStyles.color.main) {
        styleRules["--custom-color-main"] = TIWStore.customStyles.color.main;

        if (TIWStore.WIDGET_DATA.code === "comfy") {
            styleRules["--custom-color-main-hover"] = "#379424";
        }
    }

    return styleRules;
});
</script>

<template>
    <aside :class="classes" :style="styles" v-bind="$attrs">
        <div v-if="TIWStore.modeIsPopup" class="tiw__backdrop" />
        <div class="tiw__wrapper">
            <slot />
        </div>
        <slot name="after-wrapper" />
    </aside>
    <RolledStatus
        v-if="TIWStore.modeIsPopup"
        :header="OperatorExecutingStore.currentStatusMessages.header"
        :status="OperatorExecutingStore.status"
        :percent="OperatorExecutingStore.percent"
    />
</template>

<style lang="scss" src="./container.scss"></style>
